<template>
    <div class="services-details-area d-flex align-items-center justify-content-center" style="min-height: 100vh;">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="services-details-image text-center mb-4">
                        <img src="../../assets/images/services/facial-aesthetics/prp-therapy/prp-main-page.webp" alt="image">
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('prp_title') }}</h3></u>
                        <p>{{ $t('prp_p1') }}</p> 
                        <p>{{ $t('prp_p2') }}</p> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>


    export default {
        name: 'PrpTherapy',
        
    };
    
</script>
